import { IFileDocument, IObjectAudit } from "../../models"

export interface IFileSubType {
    Id: string
    ExternalId: string
    Name: string
    CategoryId: string
    CategoryName: string
    FileType: EFileTypes
    ContextType: EFileContextTypes
    CurrentFileVersion: IFileSubTypePayload
    FileSubTypePayloads: IFileSubTypePayload[]
    CompositeFilePieces: IFileSubType[]
    IzendaReportId: string
    IzendaReportName: string
    Order: number
    CurrentPayloadId: string
    Active: boolean
    HideInEss: boolean
    ObjectAudit: IObjectAudit
    Deleted: boolean
    TicksSinceChange: number
}

export interface IFileSubTypePayload {
    Id: string
    Version: number
    PDFTemplate: IFileDocument
    PDFAttributeMapItems: IPDFAttributeMapItem[]
}

export interface IPDFAttributeMapItem {
    ObjectAttributeName: string
    PDFFieldName: string
    AutoFillPDFFromSystemData: boolean
    AutoAssignPropertyInDestinationObject: boolean
}

export enum EFileContextTypes {
    User = 0,
    Client = 1,
    Contact = 2,
    Job = 3
}

export enum EFileTypes {
    PDF = 0, //Composite
    PDFTemplate = 1,
    Composite = 2, //Composite
    Image = 3,
    Report = 4,
    Application = 5
}